import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {WSUinList} from "../types/WebSocketTypes"
import {uinListApi} from "../api/uinListApi"
import {UinListsResponse} from "../models/response"

export type UinListsFilter = {
    limit: number
    offset: number
}

export type UinListsFilterQuery = {
    idCompany?: number
    status?: "-1" | "0" | "1"
    search?: string
}

type InitialStateType = {
    uinList: null | UinListsResponse
    filter: UinListsFilter & UinListsFilterQuery
    ws: WSUinList | null
}

const initialState: InitialStateType = {
    uinList: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const uinListReducer = createSlice({
    name: 'uinListReducer',
    initialState,
    reducers: {
        setUinList(state, {payload}) {
            state.uinList = payload
        },
        setUinListFilter(state, {payload}) {
            state.filter = payload
        },
        setWSUinList(state, {payload}: PayloadAction<WSUinList | null>) {
            state.ws = payload
        },
    },
})

export const {setUinList, setUinListFilter, setWSUinList} = uinListReducer.actions

export default uinListReducer.reducer

export const getUinList = asyncCreator
('uinListReducer/getUinList', uinListApi.getUinList, setUinList)

export const createUin = asyncCreator
('uinListReducer/createUin', uinListApi.createUin)

export const deleteUin = asyncCreator
('uinListReducer/deleteUin', uinListApi.deleteUin)